import numberFormat from '@/lib/numberFormat'

let currencyFormat = {
  install: (app, options) => {
    app.config.globalProperties.$currencyFormat = numberFormat
    app.provide('currencyFormat', numberFormat)
  }
}

export default currencyFormat
